import type { AttentionTier } from "./types";

/**
 * A colour mixed against the card's ink. `--attn-ink` is set once per surface by
 * attention-card-large.css (dark on light surfaces, paper on dark surfaces), so a
 * mix here always agrees with the surface it sits on.
 */
export const opacityMix = (pct: number): string =>
  `color-mix(in srgb, var(--attn-ink) ${pct}%, transparent)`;

/**
 * The single light/dark decision for the card surface, emitted as `data-surface`.
 * Capture and media cards are always a light surface regardless of tier; among
 * tier-coloured cards only routine is light. The CSS ink bundle and the web
 * feedback tone both read this, so they cannot drift from the surface.
 */
export function isLightSurface(
  tier: AttentionTier,
  variant: "default" | "capture",
  hasMedia: boolean,
): boolean {
  return variant === "capture" || hasMedia || tier === "routine";
}
